export default () => ({
    visible: true,
    scrollY: 0,
    lastScrollY: 0,
    ticking: false,

    init() {
        document.addEventListener('scroll', () => this.handleScroll())

        this.$watch('visible', value => {
            if (!value) {
                this.$store.nav.close()
            }
        })
    },

    handleScroll() {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.scrollY = window.scrollY

                this.toggleHeaderVisibility(this.scrollY, this.lastScrollY)

                this.lastScrollY = window.scrollY
                this.ticking = false
            });

            this.ticking = true
        }
    },
    toggleHeaderVisibility(currentScrollY, lastScrollY) {
        if (currentScrollY > 60 && currentScrollY > lastScrollY) {
            this.visible = false
        } else if (currentScrollY < lastScrollY) {
            this.visible = true
        }
    }
})
